import { render, staticRenderFns } from "./ShareActivityDetails.vue?vue&type=template&id=4af5fb7c&scoped=true"
import script from "./ShareActivityDetails.vue?vue&type=script&lang=js"
export * from "./ShareActivityDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af5fb7c",
  null
  
)

export default component.exports